import React from 'react';

import PropTypes from 'prop-types';

const propTypes = {
  className: PropTypes.string,
  Text: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

function Button({
  className = '',
  Text = '',
  title = '',
  disabled = false,
  onClick = () => {},
}) {
  return (
    <button
      onClick={onClick}
      className={className}
      title={title}
      disabled={disabled}
    >
      {Text}
    </button>
  );
}

Button.propTypes = propTypes;

export default Button;
